<template>
  <div
    v-show="hasContent"
    class="buttonSet"
  >
    <div
      v-show="label || description"
      class="buttonSet__header"
    >
      <span
        v-show="label"
        class="buttonSet__label"
      >{{ label }}</span>
      <p
        v-show="description"
        v-html="description"
        class="buttonSet__description"
      />
    </div>
    <div class="buttonSet__content">
      <slot />
    </div>
    <div
      v-show="notes"
      class="buttonSet__footer"
    >
      <p
        v-html="notes"
        class="buttonSet__notes"
      />
    </div>
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'

export default {
  name: 'InputfieldButtonSet',
  mixins: [
    InputfieldMixin,
  ],
  props: {
    name: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
  },
  computed: {
    hasContent () {
      return !!this.$slots.default
    },
  },
}

</script>

<style lang="scss" scoped>

.buttonSet {
  &__content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: -.5em;
  }

  .field {
    margin: .5em;
  }
}

</style>
